// extracted by mini-css-extract-plugin
export var chevronIcon = "_5z-2";
export var teamName = "_5z-1";
export var teamSwitcherButton = "_5z-0";